import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitConfigurationSubmissionData } from '../../../../../../models/submissions/variable-benefit-configuration-submission-data';
import { PaymentMethodTypeIdEnum } from '../../../../../../models/enum/shared/payment-method-type-id.enum';

@Component({
  selector: 'app-vb-config-deposit-instructions-review-card',
  templateUrl: './vb-config-deposit-instructions-review-card.component.html',
  styleUrls: ['./vb-config-deposit-instructions-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigDepositInstructionsReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitConfigurationSubmissionData;

  public isWrittenCheque = false;

  public ngOnChanges(): void {
    this.isWrittenCheque = this.submission?.paymentMethodId === PaymentMethodTypeIdEnum.Cheque;
  }
}
